import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Popup from "../Popup";
import { getCalendar } from "utils/date";
import RollingPicker from "./RollingPicker";
import Button from "../Button";
import iconDrop from "assets/icons/icon_drop_black.svg";
import iconDropFill from "assets/icons/icon_drop_fill.svg";

export const DatePicker = ({
  isFillDrop = false,
  mode,
  onChange,
  ...props
}) => {
  const getDefaultDate = () => {
    const date = new Date(props.date || getCalendar());
    if (mode == "year" || mode == "month") date.setDate(1);
    if (mode == "year") date.setMonth(0);
    return date.getCalendar();
  };
  const [date, setDate] = useState(getDefaultDate());
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    return () => {
      setVisible(false);
    };
  }, []);

  useEffect(() => {
    getDefaultDate();
  }, [props.date]);

  const eventHandler = {
    open: () => {
      setDate(getDefaultDate());
      setVisible(true);
    },
    close: () => {
      setVisible(false);
    },
    change: (type, value) => {
      const oldDate = new Date(date);
      const newDate = new Date(date);

      switch (type) {
        case "year":
          newDate.setFullYear(value);
          if (newDate.getMonth() != oldDate.getMonth()) {
            newDate.setMonth(oldDate.getMonth());
            newDate.setDate(newDate.getEndDateInMonth().getDate());
          }
          break;
        case "month":
          newDate.setMonth(value - 1);
          if (newDate.getMonth() != value - 1) {
            newDate.setMonth(value - 1);
            newDate.setDate(newDate.getEndDateInMonth().getDate());
          }
          break;
        case "day":
          newDate.setDate(value);
          break;
      }
      setDate(newDate.getCalendar());
    },
    submit: () => {
      if (onChange) {
        onChange(date);
      }
      eventHandler.close();
    },
  };

  const render = () => {
    const getList = (type) => {
      let min, max, suffix, value;
      switch (type) {
        case "year":
          max = props.maxYear
            ? Number(props.maxYear)
            : new Date().getFullYear();
          min = props.minYear ? Number(props.minYear) : 1900;
          suffix = "년";
          value = new Date(date).getFullYear();
          break;
        case "month":
          if (mode == "year") return null;
          max = 12;
          min = 1;
          suffix = "월";
          value = new Date(date).getMonth() + 1;
          break;
        case "day":
          if (mode == "year" || mode == "month") return null;
          max = new Date(date).getEndDateInMonth().getDate();
          min = 1;
          suffix = "일";
          value = new Date(date).getDate();
          break;
      }
      const options = [];
      for (let i = min; i <= max; i++) {
        options.push({ label: i + suffix, value: i });
      }
      return (
        <RollingPicker
          value={value}
          options={options}
          onChange={(value) => {
            eventHandler.change(type, value);
          }}
        />
      );
    };
    const getLabel = () => {
      const getFormat = () => {
        switch (mode) {
          case "year":
            return "yyyy";
          case "month":
            return "yyyy-mm";
          case "day":
            return "yyyy-mm-dd";
        }
      };
      let format = props.format ? props.format : getFormat();
      return <h4>{new Date(props.date || getCalendar()).format(format)}</h4>;
    };
    return (
      <Wrapper {...props}>
        <div
          className={props.children ? null : "drop"}
          onClick={eventHandler.open}
        >
          {props.children ? props.children : getLabel()}
          {isFillDrop ? <img src={iconDropFill} /> : <img src={iconDrop} />}
        </div>
        <StyledPopup open={visible} onClose={setVisible}>
          <div className="top">
            <h3>날짜선택</h3>
          </div>
          <div className="middle">
            {getList("year")}
            {getList("month")}
            {getList("day")}
          </div>
          <div className="bottom">
            <Button color="blue" onClick={eventHandler.submit}>
              확인
            </Button>
          </div>
        </StyledPopup>
      </Wrapper>
    );
  };
  return render();
};

const Wrapper = styled.div`
  & > div:first-child {
    cursor: pointer;
  }
  & > div:first-child.drop {
    display: inline-flex;
    align-items: center;
    & > img {
      width: 11px;
      height: 11px;
      margin-left: 6px;
    }
  }
`;

const StyledPopup = styled(Popup)`
  .middle {
    display: flex;
    margin: 0 -5px;
    justify-content: center;
    height: calc(42px * 5);
    overflow: hidden;
  }
  .middle > div {
    position: relative;
    padding: 0 5px;
    width: 100%;
    font-size: 18px;
    font-weight: 600;
  }
  .middle > div:before {
    content: "";
    position: absolute;
    left: 5px;
    top: 50%;
    right: 5px;
    height: 42px;
    background-color: #f3f6fd;
    border-radius: 8px;
    transform: translateY(-50%);
  }
  .middle li {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
  }
`;

export default DatePicker;
